import React, { useState, useEffect, useRef } from 'react';
import Textfield from 'syf-component-library/ui/atoms/Textfield';
import Textarea from 'syf-component-library/ui/atoms/Textarea';
import { ControlWrapper } from './control.styles';
const InvalidData = "Please enter information in correct format";
export const MatchFail = "MatchFail";
const inputValidation = (value, regexStr, validationtext, matchValue) => {
    let errText;
    if (regexStr) {
        const regex = new RegExp(regexStr);
        if (!regex.test(value)) {
            errText = validationtext || InvalidData;
        }
    }
    if (!errText && matchValue && value !== matchValue) {
        errText = MatchFail;
    }
    return errText;
};
const TextboxControl = (props) => {
    var _a;
    const [value, setValue] = useState(props.value);
    const [isrequired] = useState(props.inputMetadata.required === 'true');
    const [optionalText] = useState(isrequired ? "" : " (optional)");
    const inputRef = useRef(null);
    useEffect(() => {
        if (props.shouldFocus && (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current)) {
            inputRef.current.focus();
        }
    });
    const onChange = (e) => {
        const val = e.target.value;
        setValue(val);
        props.onChange({
            id: props.inputMetadata.id,
            isvalid: (!!(isrequired && val) || !isrequired),
            value: val,
        });
    };
    const onBlur = () => {
        let errText;
        if (props.valid) {
            errText = inputValidation(value, props.inputMetadata.validation, props.inputMetadata.validationtext, props.matchValue);
            if (errText) {
                props.onChange({
                    id: props.inputMetadata.id,
                    isvalid: false,
                    value,
                    error: errText,
                });
            }
        }
    };
    const htmlProps = {
        'aria-label': props.inputMetadata.labeltext,
        'aria-labelledby': `syf-help-text-${props.inputMetadata.id}`,
        tabIndex: props.tabIndex,
    };
    const textAreaProps = {
        required: isrequired,
        maxlength: props.inputMetadata.maxlength,
        onChange: onChange,
        error: props.error,
        onBlur: onBlur,
        'aria-describedby': `syf-help-text-${props.inputMetadata.labeltext}`,
    };
    return (React.createElement(ControlWrapper, { hasError: !!props.error }, props.inputMetadata.multiline === 'true' ?
        React.createElement(Textarea, Object.assign({ id: `Alme-Overlay-Form-${props.inputMetadata.id}`, autoCapitalize: "none", name: props.inputMetadata.id, placeholder: props.inputMetadata.labeltext + `${optionalText}`, sizeRatio: 5, dynamicHeight: false, value: value, textfieldRef: inputRef }, htmlProps, textAreaProps))
        : React.createElement(Textfield, Object.assign({ id: `Alme-Overlay-Form-${props.inputMetadata.id}`, autoCapitalize: "none", name: props.inputMetadata.id, maxLength: ((_a = props === null || props === void 0 ? void 0 : props.inputMetadata) === null || _a === void 0 ? void 0 : _a.match) === "MatchingAccountNumbers" ? 17 : undefined, placeholder: props.inputMetadata.labeltext + `${optionalText}`, width: '275px', required: isrequired, type: "text", value: value, textfieldRef: inputRef, className: "iva-text-input-field-container", inputClassName: "iva-text-input-field", onChange: onChange, error: props.error, onBlur: onBlur, autoComplete: props.autoComplete, showMaskedOption: props.inputMetadata.mask === 'true' }, htmlProps))));
};
export default TextboxControl;
